import React from 'react';
export const StatsSection = () => {
  return <section className="py-16 bg-blue-700 text-white" data-id="element-249">
      <div className="container mx-auto px-4" data-id="element-250">
        <div className="text-center mb-12" data-id="element-251">
          <h2 className="text-3xl font-bold mb-4" data-id="element-252">
            Making Government Services Accessible
          </h2>
          <p className="text-blue-100 max-w-2xl mx-auto" data-id="element-253">
            Our platform has transformed how citizens interact with government
            services, making them more accessible, efficient, and transparent.
          </p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center" data-id="element-254">
          <div data-id="element-255">
            <div className="text-4xl font-bold mb-2" data-id="element-256">200+</div>
            <p className="text-blue-100" data-id="element-257">Online Services</p>
          </div>
          <div data-id="element-258">
            <div className="text-4xl font-bold mb-2" data-id="element-259">2.5M+</div>
            <p className="text-blue-100" data-id="element-260">Registered Users</p>
          </div>
          <div data-id="element-261">
            <div className="text-4xl font-bold mb-2" data-id="element-262">15M+</div>
            <p className="text-blue-100" data-id="element-263">Services Delivered</p>
          </div>
          <div data-id="element-264">
            <div className="text-4xl font-bold mb-2" data-id="element-265">98%</div>
            <p className="text-blue-100" data-id="element-266">Satisfaction Rate</p>
          </div>
        </div>
      </div>
    </section>;
};